module.exports = __webpack_public_path__ + "img/sind-die-lichter.c4c28864.jpeg";